import { render, staticRenderFns } from "./BiChannelDateSearch.vue?vue&type=template&id=5bd5f6a5&scoped=true"
import script from "./BiChannelDateSearch.vue?vue&type=script&lang=js"
export * from "./BiChannelDateSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5f6a5",
  null
  
)

export default component.exports